import React from 'react';
import { Backdrop, Portal } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles()(theme => ({
  backdrop: {
    zIndex: theme.zIndex.appBar + 1,
  },
  element: {
    zIndex: theme.zIndex.appBar + 2,
  },
}));


export type FocusedElementProps = {
  open: boolean;
  children: React.ReactElement;
  onClose?: () => void;
};


export const FocusedElement: React.VFC<FocusedElementProps> = (props) => {
  const { classes, cx } = useStyles();
  const children = React.useMemo(() => React.cloneElement(props.children, {
    ...props.children.props,
    className: cx(props.children.props.className, {
      [classes.element]: props.open,
    })
  }), [ props.children, props.open, classes.element ]);

  return (
    <>
      {children}
      <Portal>
        <Backdrop open={props.open} className={classes.backdrop} onClick={props.onClose} />
      </Portal>
    </>
  );
};
